export const isNavigableUrl = (value: unknown): value is string => {
  if (typeof value !== "string" || value === "") return false;
  try {
    const { protocol } = new URL(value, window.location.origin);
    return protocol === "https:" || protocol === "http:";
  } catch {
    return false;
  }
};
